import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { winstonConfig } from '../common/logger/winston.config';
import { OfertasController } from './ofertas.controller';
import { OfertasService } from './ofertas.service';

@Module({
  imports: [PrismaModule],
  controllers: [OfertasController],
  providers: [OfertasService],
  exports: [OfertasService],
})
export class OfertasModule {}
